import { render, staticRenderFns } from "./CreateArticlePanel.vue?vue&type=template&id=92302af6"
import script from "./CreateArticlePanel.vue?vue&type=script&lang=js"
export * from "./CreateArticlePanel.vue?vue&type=script&lang=js"
import style0 from "./CreateArticlePanel.vue?vue&type=style&index=0&id=92302af6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports